<template>
  <div :class="type === 'number' ? 'flex-display' : ''" v-click-outside="outside">
    <div v-if="type === 'number'">
      <img height="21px" width="21px" class="increment background-white" @click="incrementNumericInput"
        src="../assets/counter-plus.png" alt="" />
      <img height="21px" width="21px" class="decrement background-e1e1e1" @click="decrementNumericInput"
        src="../assets/counter-minus.png" alt="" />
    </div>
    <div :class="type === 'number' ? 'width-100 display-grid' : 'display-grid'">
      <label :class="[
          icon ? 'padding-left-24' : '',
          disabled ? 'disableCursor' : '',
        ]" ref="label" @click="labelClick">
        {{ label }}<span v-if="required == true" style="color: #ff0000">*</span>
      </label>
      <label v-if="icon" @click="labelClick" style="margin-top: 14px" :class="disabled ? 'disableCursor' : ''">
        <!-- <i :class="icon + ' color-black'"></i> -->
        <img class="custom-icon" :src="getFieldIcon(icon)" alt="" />
      </label>
      <span :class="icon ? 'error-text' : 'error-text'" style="padding-left:16px" @click="spanClick"
        v-if="type !== 'datePicker'">{{ error }}</span>
      <span v-if="!error" :class="icon ? 'helping-text padding-left-16' : 'helping-text'" @click="spanClick">{{
        helpingText }}</span>
      <label class="arrow-right" :style="widthOfInput">
        <img v-if="this.value && clearButtonIcon" :src="require('../assets/close.png')"  width="20px" height="20px" @click="clear" alt="" />
      </label>
      <input
        :pattern="pattern"
        :data-cy="CY"
        @keydown.enter.prevent="enterKeyDown"
        v-bind:value="value"
        @input="handleInput"
        @blur="handleBlur"
        ref="input"
        :class="[
          icon
            ? border
              ? ' form-control has-error padding'
              : ' form-control no-border has-error padding'
            : border
            ? ' form-control has-error'
            : ' form-control no-border has-error',
        ]" :type="type" :placeholder="placeholder" :disabled="disabled" :readonly="readonly" :min="min"
        :maxlength="max" @focus="focus"  @click="click" :style="[
          width ? 'width:' + width : '',
          error ? borderColorRed : '',
          disabled ? borderColorDisabled : '',
        ]" v-on:keyup.enter="onEnter"
      />
      <Calendar style="position: absolute; margin-top: 44px" :class="[error ? borderColorRed : '']" v-model="date" @input="inputDate"
        v-if="type === 'datePicker'" v-show="showCalendar" ref="calendar" @focus="focusCalendar" @blur="blurCalendar" />
      <span :class="'error-text'" style="padding-left:15px;"  @click="spanClick" v-if="type === 'datePicker'">{{ error }}</span>
    </div>
  </div>
</template>
<script>
  import * as JSFunctions from "../Functions/Functions.js";
  import Calendar from "./calendar/Calendar.vue";

  import Constants from "../../src/shared/Constants";

  import moment from "moment";
  export default {
    name: "SInput",
    components: { Calendar },

    data() {
      return {
        borderColorRed: {
          "border-color": "var( --text-error-color)",
          outline: "none",
          "box-shadow": "none",
        },
        borderColorDisabled: {
          "border-color": "var( --disable)",
        },

        uuid: "",
        inputLabelId: "",
        inputId: "",
        content: this.value,
        date: "",
        showCalendar: false,
        notFirstTime: false,
      };
    },
    mounted() {
      // window.console.log('build is success fully updated or not testing 123')
      this.notFirstTime = true;
      if (
        (this.value != undefined &&
          this.value != "undefined" &&
          this.value != null &&
          this.value != "null") ||
        this.placeholder
      ) {
        if (this.type !== "datePicker" || this.disabled) {
          //To focus the field if a preset is available, so that placeholder and value don't overlap.
          // console.log(this.label);
          this.focus();
        }
      }
      if (this.type === "datePicker") {
        // this.type='text'
        this.date = this.value;
        if (this.placeholder) {
          this.focus();
        }
        if (
          this.value != undefined &&
          this.value != "undefined" &&
          this.value != null &&
          this.value != "null"
        ) {
          this.focus();
        }
        if (!this.date) {
          return;
        }
        if (!this.border) {
          this.$refs.label.className = "label-focus-no-bordered";
        }
        if (this.readonly || this.disabled) {
          return;
        }
        if (this.border) {
          this.$refs.label.className = "label-focus";
        }
      }
    },
    computed: {
      widthOfInput() {
        if (this.notFirstTime) {
          return {
            right: "16px",
          };
        } else {
          return "";
        }
      },
    },
    methods: {
      onEnter(event) {
        this.$emit("enter", event.target.value);
      },
      inputDate(value) {
        if (value != undefined) {
          let momentDate = moment(value);
          if (!momentDate) {
            return "";
          }
          value = momentDate.format(this.dateFormat);
          this.$emit("input", value);
          this.focus();
        }
      },

      handleInput: function (event) {
        // console.log(event)
        this.$emit("input", event.target.value);
      },

      handleBlur: function (event) {
        this.$emit("blur", event.target.value);
      },

      onChangeFn: function (value) {
        this.$emit("change", value);
      },

      incrementNumericInput() {
        if (this.readonly || this.disabled) {
          return;
        }
        if (!this.value) {
          this.$refs.input.value = 0;
          // return;
        }

        let event = {
          target: {
            value: parseInt(this.$refs.input.value) + 1,
          },
        };
        this.handleInput(event);
        this.focus();
      },

      decrementNumericInput() {
        if (this.readonly || this.disabled) {
          return;
        }
        if (!this.value) {
          this.$refs.input.value = 0;
        }

        // if (this.$refs.input.value==0) {
        //   return;
        // }
        let event = {
          target: {
            value: parseInt(this.$refs.input.value) - 1,
          },
        };
        this.handleInput(event);
        this.focus();
      },

      focus() {
        if (!this.border) {
          this.$refs.label.className = "label-focus-no-bordered";
        }
        if (this.type === "datePicker" && !this.disabled) {
          if (!this.border) {
            this.$refs.label.className = "label-focus-no-bordered";
          } else {
            this.$refs.label.className = "label-focus";
          }
        }
        if ((this.readonly || this.disabled) && this.value) {
          // return;
          this.$refs.label.className = "label-focus";
        }
        if (this.border) {
          this.$refs.label.className = "label-focus";
        }
      },

      blur() {
        let value = this.$refs.input.value;
        value || this.placeholder
          ? this.border
            ? (this.$refs.label.className = "label-focus")
            : (this.$refs.label.className = "label-focus-no-bordered")
          : this.icon
            ? (this.$refs.label.className = "padding-left-24")
            : (this.$refs.label.className = "");
      },

      labelClick() {
        this.$refs.input.focus();
        if (this.type === "datePicker") {
          this.showCalendar = !this.showCalendar;
        }
      },

      spanClick() {
        this.$refs.input.focus();
        if (this.type === "datePicker" && !this.disabled) {
          this.showCalendar = !this.showCalendar;
        }
      },

      click() {
        if (this.type === "datePicker") {
          this.showCalendar = !this.showCalendar;
          if (this.showCalendar) {
            this.$refs.calendar.focus();
          } else {
            this.blurCalendar();
          }
        }
        this.$emit("click");
      },

      focusCalendar(event) {
        this.showCalendar = true;
        if (event) {
          event.stopPropagation();
        }
      },

      blurCalendar() {
        this.showCalendar = false;
      },

      outside() {
        if (this.showCalendar) {
          this.showCalendar = false;
        }
      },

      getFieldIcon(icon) {
        return require("../assets/" + icon + ".png");
      },
      /**
       * Clear all values, results and errors
       */
      clear() {
        this.display = null;
        this.value = null;
        this.results = null;
        this.ulError = null;
        this.$attrs.value = "";
        this.$emit("clear");
      },
    },
    props: {
      pattern: String,
      CY: String,
      enterKeyDown: Function,
      label: String,
      hint: String,
      error: String,
      placeholder: String,
      disabled: Boolean,
      readonly: Boolean,
      required: Boolean,
      /**
       * Optional clear button show/hide
       */
      clearButtonIcon: {
        type: Boolean,
        default: true,
      },
      type: {
        default: "text",
      },
      icon: String,
      min: String,
      max: String,
      border: { type: Boolean, default: true },
      value: {},
      width: {},
      dateFormat: {
        default: Constants.dateFormat,
      },
      helpingText: String,
    },

    watch: {
      value(event) {
        this.focus();
        this.onChangeFn(event);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .disableCursor {
    pointer-events: none;
    cursor: not-allowed;
  }

  label {
    position: absolute;
    font-size: 14px;
    line-height: 1;
    margin-top: 14px;
    margin-left: 16px;
    cursor: text;
    color: var(--brown-grey);
    text-transform: capitalize !important;
  }

  .label-focus {
    margin-top: -4px;
    margin-left: 8px;
    padding-right: 8px;
    padding-left: 8px;
    background-color: #fff;
    font-size: 10px;
    font-weight: bold;
    line-height: 1.25;
    color: var(--black);
    text-transform: uppercase !important;
  }

  .label-focus-no-bordered {
    background-color: #fff;
    margin-top: -8px;
    margin-left: 8px;
    padding-right: 8px;
    padding-left: 8px;
      font-family: "Roboto !important";
    font-size: 10px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: normal;
    color: var(--black);
    text-transform: uppercase !important;
  }

  .padding {
    padding-left: 40px !important;
  }

  .padding-left-24 {
    padding-left: 24px;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="date"]::-webkit-inner-spin-button,
  input[type="date"]::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
  }

  .increment {
    display: block;
    cursor: pointer;
    font-size: 9px;
  }

  .background-grey {
    background-color: var(--brown-grey);
  }

  .decrement {
    display: block;
    cursor: pointer;
    font-size: 9px;
  }

  .flex-display {
    display: flex;
    align-items: flex-start;
  }

  .width-100 {
    width: 100%;
  }

  .color-black {
    color: #000000;
  }

  .no-border {
    border: 0 !important;
    box-shadow: inset 0 0 0 rgba(0, 0, 0, 0) !important;
  }

  .error-text {
    position: absolute;
      font-family: "Roboto !important";
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    padding-top: 47px;
    color: #ff0000;
    text-transform: capitalize;
  }

  .helping-text {
    position: absolute;
      font-family: "Roboto !important";
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    padding-top: 42px;
    color: var(--black);
  }

  .padding-left-40 {
    padding-left: 40px;
  }

  .padding-left-16 {
    padding-left: 16px;
  }

  border-color {
    border-color: #ff0000;
  }

  .arrow-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;

    .close-icon {
      width: 30px !important;
    height: 48px !important;
      padding-right: 2px;
      margin-right: -7px;
      // transform: rotate(135deg);
      // border-top: 2px solid #e1e1e1;
      // border-right: 2px solid #e1e1e1;
    }
  }

  // test
</style>